import { ComparisonChartCard } from '../ComparisonChartCard';
import { ComparisonData } from '../comparisonTable.config';
import useComparisonChartData from '../hooks/useComparisonChartData';

interface ComparisonChartsContainerProps {
  comparisonData: ComparisonData[];
}

const ComparisonChartsContainer = ({ comparisonData }: ComparisonChartsContainerProps) => {
  const { chartsValues, comparisonChartsLabels, labels } = useComparisonChartData({
    comparisonData,
  });

  return (
    <div
      className="mt-2 flex flex-wrap gap-2
        [&>*]:max-h-[700px]
        [&>*]:min-w-full
        [&>*]:flex-1
        [&>*]:lg:min-w-[calc(50%-0.5rem)]
        [&>*]:xxl:min-w-[calc(33.333%-0.5rem)]"
    >
      {Object.keys(chartsValues).map((key) => (
        <ComparisonChartCard key={key} label={key} chartsValues={chartsValues} labels={labels} />
      ))}
    </div>
  );
};

export default ComparisonChartsContainer;
